// The kit's keyboard focus ring: a 2px Accent outline 2px outside the element.
// Focus is not drawn in the Figma, so this is the kit's own treatment, the same on
// every interactive component, and it is keyboard-only: it keys off react-aria's
// `data-focus-visible`, which a pointer press never sets.
//
// Each ring sets `outline-solid` itself. Tailwind v4's `outline-none` sets
// `--tw-outline-style: none`, and `outline-2` draws with
// `outline-style: var(--tw-outline-style)`, so a ring of `outline-2` alone on an
// element that resets with `outline-none` renders with style none: no ring at all.

/** The focus ring of a react-aria control (Button, Link, Switch, Radio, DropZone, Row...). */
export const focusRing =
	'outline-none data-focus-visible:outline-solid data-focus-visible:outline-2 data-focus-visible:outline-offset-2 data-focus-visible:outline-atlas-accent'

/**
 * The focus ring of a field's wrapper, drawn while its input or textarea has keyboard
 * focus. A text field matches the CSS `:focus-visible` on a click as well, so this
 * keys off the field's own `data-focus-visible`, which react-aria sets for keyboard
 * focus only.
 */
export const fieldFocusRing =
	'has-[:is(input,textarea)[data-focus-visible]]:outline-solid has-[:is(input,textarea)[data-focus-visible]]:outline-2 has-[:is(input,textarea)[data-focus-visible]]:outline-offset-2 has-[:is(input,textarea)[data-focus-visible]]:outline-atlas-accent'
